const TABS = [
  { key: 'components', label: 'Components', icon: '\u2630' },
  { key: 'inputs', label: 'Inputs', icon: '\u25C7' },
  { key: 'materials', label: 'Materials', icon: null },
  { key: 'childRecipes', label: 'Child Recipes', icon: null },
  { key: 'variations', label: 'Variations', icon: '\u21C5' }
]

const RecipeTabs = ({ active, onChange, counts }) => {
  return (
    <div className="tabs">
      {TABS.map(tab => (
        <button
          key={tab.key}
          className={`tab${active === tab.key ? ' active' : ''}`}
          onClick={() => onChange(tab.key)}
        >
          {tab.icon && <span className="tab-icon">{tab.icon}</span>}
          {tab.label}
          {counts[tab.key] != null && (
            <span className="count">{counts[tab.key]}</span>
          )}
        </button>
      ))}
    </div>
  )
}

export default RecipeTabs
